export default "__VITE_ASSET__DxvPpwkE__"